import { Subtitle1, Tooltip } from '@fluentui/react-components'
import { ArrowLeftRegular } from '@fluentui/react-icons'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { useStyles } from './PageHeader.styles'

interface PageHeaderProps {
  title: string
  actions?: ReactNode
}

const PageHeader = ({ title, actions }: PageHeaderProps) => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <div className={classes.header}>
      <div className={classes.headerLeft}>
        <Tooltip content={t('homeReturn')} relationship="label" appearance="inverted">
          <Link to="/" className={classes.link} aria-label={t('homeReturn')}>
            <ArrowLeftRegular className={classes.backIcon} />
          </Link>
        </Tooltip>
        <Subtitle1 as="h2" className={classes.heading}>
          {title}
        </Subtitle1>
      </div>
      {actions ? <div className={classes.actions}>{actions}</div> : null}
    </div>
  )
}

export { PageHeader }
